import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Grid } from '@mui/material';
import NavCard from './DrawerContent/NavCard';
import NavCardIcon from './DrawerContent/NavCardIcon';

// project-imports
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled, { SIDEBAR_BORDER, getSidebarBg, isSecurity } from './MiniDrawerStyled';

import { DRAWER_WIDTH } from 'config';
import { dispatch, useSelector } from 'store';
import { openDrawer } from 'store/reducers/menu';


// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ window }) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { drawerOpen } = useSelector((state) => state.menu);

  // responsive drawer container
  const container = window !== undefined ? () => window().document.body : undefined;

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={drawerOpen} />, [drawerOpen]);

  // Security only ever uses the Check-in page — the full nav tree and the Check-in shortcut
  // button both have nothing else relevant for them, so the sidebar shows just the logo.
  const hideMenu = isSecurity();

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1200 }} aria-label="mailbox folders">
      {!downLG ? (
        <MiniDrawerStyled variant="permanent" open={drawerOpen}>
          {drawerHeader}
          {/* {drawerContent} */}
          {!hideMenu && drawerContent}
          {/* <Grid item sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center', marginBottom: '15px' }}>
            {drawerOpen ? <NavCard /> : <NavCardIcon />}
          </Grid> */}
          {!hideMenu && (
            <Grid item sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center', marginBottom: '15px' }}>
              {drawerOpen ? <NavCard /> : <NavCardIcon />}
            </Grid>
          )}
        </MiniDrawerStyled>
      ) : (
        <Drawer
          container={container}
          containerstyle={{ height: 'calc(100% - 64px)', top: 64 }}
          variant="temporary"
          open={drawerOpen}
          onClose={() => dispatch(openDrawer(!drawerOpen))}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              display: 'flex',
              alignContent: 'flex-end',
              width: DRAWER_WIDTH,
              borderRight: `1px solid ${SIDEBAR_BORDER}`,
              backgroundImage: 'none',
              background: getSidebarBg(),
              boxShadow: 'inherit'
            }
          }}
        >
          {drawerHeader}
          {!hideMenu && drawerContent}
          {!hideMenu && (
            <Grid item sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center', marginBottom: '15px' }}>
              {drawerOpen ? <NavCard /> : <NavCardIcon />}
            </Grid>
          )}
        </Drawer>
      )}
    </Box>
  );
};

MainDrawer.propTypes = {
  open: PropTypes.bool,
  window: PropTypes.object,
  handleDrawerToggle: PropTypes.func
};

export default MainDrawer;
